import type { GetArtistPageNftsQuery } from '#lib/websites/artists/queries/__generated__/getArtistPageNfts.generated.js';

export const transformInfiniteDataNfts = (data: GetArtistPageNftsQuery) => {
	return data.Artists[0].nft_collections || [];
};
